module.exports = __webpack_public_path__ + "img/1516956135.0283d36f.jpg";